export default __webpack_public_path__ + "static/viitorul-b460a79c98ff4f3623c6a0b4c680adf2.jpg";